import wixFetch from 'wix-fetch';

$w.onReady(function () {
    wixFetch.fetch("https://www.lm-mikrotuki.fi/_functions/getAllPagesSEO", { method: "GET" })
    .then(response => response.json())
    .then(data => {
        console.log("✅ Kaikki SEO-tiedot haettu:", data);
    })
    .catch(error => console.error("❌ Virhe SEO-tietojen haussa:", error));
});
